import { render, staticRenderFns } from "./image-select.vue?vue&type=template&id=5bdf7296&scoped=true&"
import script from "./image-select.vue?vue&type=script&lang=js&"
export * from "./image-select.vue?vue&type=script&lang=js&"
import style0 from "./image-select.vue?vue&type=style&index=0&id=5bdf7296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf7296",
  null
  
)

export default component.exports